<template>
    <div style="overflow-y: hidden;">
        <div class="ppt_con" style="height: 100vh;"></div>
        <el-dialog v-model="centerDialogVisible" title="关于计次体系的说明" width="500" center style="border-radius: 15px;">
            <div class="text_content">
                <p>MagicPPT生成PPT的流程是：生成大纲->确认大纲->挑选模板->生成->编辑->下载（如需）
                    其中每执行一次流程即为1次。</p>
                <p>流程开始的标志是“生成大纲”，即每生成一次大纲均会计次1次，重新生成大纲亦被认为是生成大纲，在此提请注意。建议您使用畅聊的“学术大纲生成”机器人生成大纲后再行使用。</p>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button type="primary" @click="closeDialog" style="background: #7733f8;border: none;">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted, ref } from 'vue';
import { getNumApi, getCodeApi, getTimesApi, getWorksNumApi, behaviorApi } from '@/api/index'
import { useRoute } from 'vue-router';
import { ElMessage, ElNotification } from 'element-plus'
import router from '@/router';
import { getCookie, clearAllCookie } from '../utils/cookei'
export default defineComponent({
    name: 'HomeView',
    components: {
    },
    setup() {
        const route = useRoute()
        let user_id = ref('')
        let centerDialogVisible = ref(false)
        let remainingTimes:any = ref(0)
        let times = ref(0)
        // 首次登录弹弹窗
        onMounted(() => {
            // 首次登录弹弹窗
            if (localStorage.getItem('ppt_cl_pay') && localStorage.getItem('ppt_cl_pay') === '1') {
                centerDialogVisible.value = true
            }
            // 获取用户id
            if (getCookie('UserInfo')) {
                user_id.value = JSON.parse(getCookie('UserInfo')).userId
            } 

            // 获取生成ppt的code
            let code = localStorage.getItem('ppt_code')
            if (code) {
                // 有code直接生成ppt
                getPpt(code)
            } else {
                // 没有code获取code
                getCode()
            }
            getNum()
        });
        
        const getCode = async () => {
            const res: any = await getCodeApi()
            if (res.code === 0) {
                if (localStorage.getItem('ppt_code')) return
                let newCode = res.data
                localStorage.setItem('ppt_code', newCode)
                getPpt(newCode)
            }
        }
        // 获取作品数量
        const getNum = async () => {
            const res:any = await getWorksNumApi('')
            const data:any = {
                event: 'view list',
                params:{
                    userId: user_id.value,
                    isSuccess: '',
                    listTime: new Date().getTime(),
                    plotNum: 0,
                    remainNum: 0,
                }
            }
            if (res.code === 0) {
                data.params.plotNum = res.data.total
                data.params.isSuccess = 'true'
            } else {
                data.params.isSuccess = 'false'
            }
            const residueDegree:any = await getTimesApi()
            if (residueDegree.code === 0) {
                if (!localStorage.getItem('ppt_cl_pay') && localStorage.getItem('ppt_cl_pay') !== '1') {
                    // 限制只弹出一次 获取class el-notification 的元素 如果存在则不弹出
                    const elNotification = document.querySelector('.el-notification')
                    if (!elNotification) {
                        ElNotification({
                            title: '使用量',
                            dangerouslyUseHTMLString: true,
                            message: residueDegree.data,
                            duration: 6000
                        })
                    }
                }
                data.params.remainNum = +residueDegree.data.split(' ')[1]
                remainingTimes.value = residueDegree.data
            }
            setBehavior(data)
        }
        // 插入ppt
        const getPpt = async (code: string) => {
            let AipptIframe = (window as any).AipptIframe
            try {
                await AipptIframe.show({
                    appkey: '65e99463c33b1',
                    channel: user_id.value,
                    code: code,
                    editorModel: true,
                    scene_auth: false,
                    // HTMLElement类型，容器节点，用于挂载iframe
                    container: document.querySelector('.ppt_con') as HTMLElement,
                    options: {
                        fc_plate: true,
                        scene_auth: true,
                    },
                    onMessage(eventType: any, data: any) {
                        let payNode = [1001, 1002, 1003, 1004, 1005, 1006, 1007, 1021]
                        // 鉴权判断
                        if (eventType === 'SCENE_AUTH') {
                            // 调用剩余次数接口，如果剩余次数为0，提示用户已无次数
                            // 判断data.scene是否属于付费几点，如果是，判断剩余次数是否大于0，如果不是，直接调用AipptIframe.sceneAuthContinue(true)
                            if (payNode.includes(data.scene)) {
                                // let form = new FormData()
                                // form.append('org_code', localStorage.getItem('ppt_cl_organ_code') as string)
                                getTimesApi().then((res: any) => {
                                    if (res.code === 0) {
                                        AipptIframe.sceneAuthContinue(true);
                                    } else {
                                        AipptIframe.sceneAuthContinue(false);
                                        ElMessage.warning('系统繁忙，请刷新后再试')
                                    }
                                })
                            } else {
                                AipptIframe.sceneAuthContinue(true);
                            }
                        }
                        if (eventType === 'OUTLINE_TITLE_CONFIRM' || eventType === 'PRESET_TITLE_CONFIRM' || eventType === 'DOCUMENT_IMPORT' || eventType === 'RETRY_OUTLINE_CONFIRM') {
                            let form = new FormData()
                            form.append('gen_mode', eventType)
                            getNumApi(form).then((res: any) => {
                                if (res.code === 1) {
                                    ElMessage.warning(res.msg)
                                }
                            })
                        }
                        if (eventType === 'TOKEN_EXPIRE ') {
                            localStorage.removeItem('ppt_code')
                            // 重新获取code
                            if (times.value < 5){
                                getCode()
                                times.value++
                            } else{
                                ElMessage.warning('系统错误，请重新登录再试')
                                setTimeout(() => {
                                    clearAllCookie();
                                    window.location.reload();
                                }, 2000);
                            }
                        }
                        // 埋点记录 
                        // 首页获取列表数量
                        if (eventType === 'ROUTER' && data.to === 'workspace') {
                            getNum()
                        }
                        // 大纲生成
                        if (eventType === 'CREATE_TASK_SUCCESS') {
                            const submitData = {
                                event: 'Generate outline',
                                params: {
                                    userId: user_id.value,
                                    isSuccess: data.data ? 'true' : 'false',
                                    listTime: new Date().getTime(), // 当前时间戳
                                    type: data.taskType,
                                }
                            }
                            console.log('submitData', submitData)
                            setBehavior(submitData)
                        }
                        // PPT制作完成
                        if (eventType === 'GENERATE_PPT_SUCCESS') {
                            const submitData = {
                                event: 'Make Success',
                                params: {
                                    userId: user_id.value,
                                    isSuccess: data.thumbnail ? 'true' : 'false',
                                    plotTime: new Date().getTime(), // 当前时间戳
                                }
                            }
                            setBehavior(submitData)
                        }
                        // 下载完成
                        if (eventType === 'PPT_DOWNLOAD') {
                            const submitData = {
                                event: 'Download',
                                params: {
                                    userId: user_id.value,
                                    isSuccess: data.status,  
                                    downTime: new Date().getTime(), // 当前时间戳
                                    downType: data.type,
                                }
                            }
                            setBehavior(submitData)
                        }
                        times.value = 0
                    }
                })
            } catch (e: any) {
                // 如果初始化code信息失效，请在此处捕捉错误信息
                console.log(e)
                // code已过期
                if (e.code === 43104) {
                    localStorage.removeItem('ppt_code')
                    // 重新获取code
                    if (times.value < 5){
                        getCode()
                        times.value++
                    } else{
                        ElMessage.warning('系统错误，请重新登录再试')
                        setTimeout(() => {
                            clearAllCookie();
                            window.location.reload();
                        }, 2000);
                    }
                }
            }
        }
        // 埋点
        const setBehavior = async (data: any) => {
            await behaviorApi(data)
        }

        const closeDialog = () => {
            centerDialogVisible.value = false
            if( remainingTimes.value ){
                ElNotification({
                    title: '使用量',
                    dangerouslyUseHTMLString: true,
                    message: remainingTimes.value,
                    duration: 6000
                })
                localStorage.removeItem('ppt_cl_pay')
            }
        }

        return {
            centerDialogVisible,
            closeDialog
        }
    },
});
</script>

<style lang="scss" scoped>
.text_content {
    padding: 0 20px;

    p {
        text-indent: 2em;
    }
}

::v-deep .el-dialog__header {
    padding: 20px;
}

.dialog-footer {
    padding: 20px;
}
</style>
<style>
.el-dialog__headerbtn:hover {
    color: #7733f8 !important;
}
</style>
